import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	['atlassian-web-crawler']: {
		id: 'dynamic-cards-search-page.products.custom-website',
		defaultMessage: 'Web page',
		description: 'display name for Web page',
	},
});
